import {InMemoryCache} from '@apollo/client';

export const cache = new InMemoryCache({
  typePolicies: {
    Account: {
      keyFields: ['ethAddress']
    },
    Transaction: {
      keyFields: ['id']
    },
    Query: {
      fields: {
        transaction: {
          read(_, {args, toReference}) {
            return toReference({
              __typename: 'Transaction',
              id: args!.id
            });
          }
        },
        transactions: {
          keyArgs: false,
          merge(existing, incoming, {args, readField}) {
            if (!existing) return incoming;
            const pageInfo = {from: 0, ...args};
            const items = existing.items ? existing.items.slice(0) : [];
            for (let i = 0; i < incoming.items.length; ++i) {
              items[pageInfo.from + i] = incoming.items[i];
            }
            return {...existing, items};
          }
        }
      }
    }
  }
});
